import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'effector-react';
import 'i18n/i18n';
import ClientApp from './app/ClientApp';
import {
  createSsrSeoAppScope,
  parseSsrSeoPublicAppState,
  SSR_SEO_APP_STATE_SCRIPT_ID,
} from './ssr/seo/appState';

const rootElement = document.getElementById('root') as HTMLElement;
const readSsrSeoAppState = () => {
  const stateElement = document.getElementById(SSR_SEO_APP_STATE_SCRIPT_ID);

  return parseSsrSeoPublicAppState(stateElement?.textContent);
};

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
      navigator.serviceWorker.register('/mindbox-services-worker.js')
          .then(registration => {
              console.log('Service Worker зарегистрирован');
          })
          .catch(error => {
              console.error('Ошибка регистрации Service Worker', error);
          });
  });
}

const ssrSeoAppState = readSsrSeoAppState();
const app = ssrSeoAppState ? (
  <Provider value={createSsrSeoAppScope(ssrSeoAppState)}>
    <ClientApp />
  </Provider>
) : (
  <ClientApp />
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
